// Logout handler for clearing auth data on logout
// This script is included in the page and listens for logout events

import { debugLog } from '../modules/jwtTokenManager.js';
import { clearAuthData } from '../modules/preferences.js';

// Function to handle logout
function handleLogout(method = 'unknown') {
  debugLog(`[JWT] Logout initiated via ${method} method`);

  try {
    clearAuthData();
    debugLog('[JWT] Auth data cleared');
  } catch (error) {
    console.error('[JWT] Error clearing auth data during logout:', error);
  }
}

// Logout is a form POST. Delegated, so forms that script adds after load are covered too
document.addEventListener('submit', (event) => {
  if (event.target instanceof HTMLFormElement && event.target.matches('form[action*="/logout"]')) {
    handleLogout('form_submit');
  }
}, true);

// Also clear auth data if this is the logout page (after redirect from logout action)
if (window.location.pathname.includes('/logout')) {
  debugLog('[JWT] Detected logout page, clearing token');
  handleLogout('logout_page');
}
